import {Modal} from 'components/ui';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useState} from 'react';
import {Button} from 'letrus-ui';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import getFeatureFlag from 'utils/functions/getFeatureFlags';
import {CTABanner} from 'containers/Dashboard/CTABanners/CTABannersCarousel';
import styles from './StreakModal.module.scss';

const streakSteps = [
  'Responder um Questionário',
  'Escrever um Texto',
  'Ver a correção do seu texto',
  'Desbloquear a Recompensa',
];

type StreakModals = 'streak' | 'success' | 'none';

function useStreakBanner({priority}: {priority: number}): CTABanner {
  const [activeModal, setActiveModal] = useState<StreakModals>('none');

  const {trackEvent} = useTrackEvent();
  const isStreakExperimentOn = getFeatureFlag('return_streak_experiment').isOn;

  function handleStreakClick() {
    setActiveModal('streak');
  }

  return {
    priority,
    title: 'Oba! Uma recompensa!',
    theme: 'light',
    color: '#fbb937',
    icon: ['fad', 'gift'],
    description:
      'Estudantes que acessam a plataforma e se dedicam à escrita podem ganhar uma recompensa ao realizar atividades.',
    isVisible: () =>
      isStreakExperimentOn &&
      !sessionStorage.getItem('hideStreakExperimentBanner'),
    action: {
      text: 'Desbloquear Recompensa',
      onClick: () => handleStreakClick(),
    },
    modals: (
      <>
        <Modal
          isOpen={activeModal === 'streak'}
          onClose={() => setActiveModal('none')}
          buttonClose={false}
          clickOutsideToClose={false}
        >
          <section className={styles.card}>
            <div className={styles.contentCard}>
              <FontAwesomeIcon
                icon={['fad', 'person-skiing']}
                color="#40357C"
                size="4x"
              />

              <h3>Junte-se a outros estudantes nessa aventura!</h3>

              <strong>Regras para ganhar a recompensa</strong>

              <span>Até o final dessa semana você deve: </span>

              <ul className={styles.steps}>
                {streakSteps?.map((step, index) => (
                  <li key={step}>
                    <FontAwesomeIcon
                      icon={
                        index === streakSteps.length - 1
                          ? ['fad', 'gift']
                          : 'circle-check'
                      }
                      color="#2FAC66"
                      size={index === streakSteps.length - 1 ? '2x' : 'lg'}
                    />
                    <span>{`${index + 1}. ${step}`}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <hr />

          <section className={styles.buttons}>
            <Button
              variant="primary"
              theme="danger"
              onClick={() => {
                setActiveModal('none');
                sessionStorage.setItem('hideStreakExperimentBanner', 'true');
                trackEvent('click_modal_desistir');
              }}
            >
              <FontAwesomeIcon icon="close" color="white" />
              Desistir
            </Button>

            <Button
              variant="primary"
              onClick={() => {
                setActiveModal('success');
                trackEvent('click_modal_quero_iniciar');
              }}
            >
              <FontAwesomeIcon icon={['fad', 'trophy']} color="black" />
              Quero a recompensa
            </Button>
          </section>
        </Modal>

        <Modal
          maxWidth={360}
          maxHeight={362}
          isOpen={activeModal === 'success'}
          onClose={() => {
            setActiveModal('none');
            sessionStorage.setItem('hideStreakExperimentBanner', 'true');
          }}
          buttonClose={false}
          clickOutsideToClose={false}
        >
          <div className={styles.success}>
            <h4>Tudo pronto!</h4>
            <strong>Realize as atividades para receber uma recompensa.</strong>
            <FontAwesomeIcon
              icon={['fad', 'circle-check']}
              color="#306230"
              size="4x"
            />
            <hr />
            <Button
              theme="success"
              onClick={() => {
                setActiveModal('none');
                sessionStorage.setItem('hideStreakExperimentBanner', 'true');
              }}
            >
              Finalizar
            </Button>
            ;
          </div>
        </Modal>
      </>
    ),
  };
}

export default useStreakBanner;
